"use strict";
/*
 * Created on 15. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AbstractReleaseTotalDTO_1 = require("./AbstractReleaseTotalDTO");
/**
 * DTO object for release "Total" tab. Object represents one product category of a release
 * and aggregated values for this category. Categories that correspond to the release parts have also associated
 * workflow status available.
 *
 * @author Radek Beran
 */


var ReleaseTotalDTO =
/*#__PURE__*/
function (_AbstractReleaseTotal) {
  _inherits(ReleaseTotalDTO, _AbstractReleaseTotal);

  /**
   * Constructs new release total info object.
   * @param categoryId id of category
   * @param priceZoneId id of price zone
   * @param nestedPriceZoneIds identifiers of nested price zones, filled only in case of DTO for release part (leaf) category
   * @param impact record of impact report
   * @param approvalStatus approval status is filled in case this is ROOT category (approval data for the whole release)
   * or release-part category (approval data for part of release)
   * @param actionFeasibilities feasibilities of workflow actions
   */
  function ReleaseTotalDTO(categoryId, priceZoneId, nestedPriceZoneIds, impact, approvalStatus, actionFeasibilities, realImpact) {
    var _this;

    _classCallCheck(this, ReleaseTotalDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReleaseTotalDTO).call(this, categoryId, approvalStatus, actionFeasibilities, realImpact));
    _this.categoryId = categoryId;
    _this.priceZoneId = priceZoneId;
    _this.nestedPriceZoneIds = nestedPriceZoneIds;
    _this.impact = impact;
    _this.approvalStatus = approvalStatus;
    _this.actionFeasibilities = actionFeasibilities;
    _this.realImpact = realImpact;
    return _this;
  }

  return ReleaseTotalDTO;
}(AbstractReleaseTotalDTO_1.AbstractReleaseTotalDTO);

exports.ReleaseTotalDTO = ReleaseTotalDTO;